<template>
  <div :class="['main', this.isLoggenIn ? 'profile stake': 'center']">
    <div v-if="this.isLoggenIn" class="container">
      <!-- Locked Funds -->
      <b-row class="mb-1">
        <b-col cols=12>
          <b-row>
            <b-col cols=12>
              <h5 class="mb-0 pb-3 pt-5 text-center txt-color-secondary">Rewards Status
                <span class='ml-0 ml-sm-3'>
                  <b-button @click="shareLink()" class="btn-sm" variant="primary">Share</b-button>
                  <b-button @click="onSubmit('withdrawRewardsPartner',0)" class="ml-3 btn-sm" style='width: 85px;' variant="primary">Withdraw</b-button>
                </span>
              </h5>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              cols=12 sm=6 md=6
              class='mb-2'
              v-for='(item, index) in getRecompensas()' v-bind:key="index"
            >
              <BalanceItem :item='item'/>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <!-- Locked Funds -->
      <b-row class="mb-5">
        <b-col cols=12>
          <b-row>
            <b-col cols=12>
              <h5 class="mb-0 pb-3 pt-5 text-center txt-color-secondary">Locked Funds</h5>
            </b-col>
            <b-col cols=12>
              <b-card no-body class='p-4'>
                <b-container class='py-2'>
                  <!--balance-->
                  <div class="row box pr-0 mb-3">
                    <b-col class="p-0 txt-color-secondary" cols=12>
                      <p class="m-0">Stake <span class="color-primary"> <strong>Balance</strong></span></p>
                      <div class="btn-l">
                        <span>SGBT</span>
                      </div>
                      <div class="input">
                        <span>{{this.GLOBAL._toDecimal(this.stake.balance, 9)}}</span>
                      </div>
                    </b-col>
                  </div>
                  <!--percentage-->
                  <b-row class="mb-3">
                    <b-col cols=4 sm=3 lg=2 class="text-center">
                      <h4 class="color-primary">{{this.stake.percentage}}%</h4>
                    </b-col>
                    <b-col cols=8 sm=9 lg=10 class="p-0">
                      <div class="progress-chart">
                        <div>
                          <div class="progress" :style="{width: + this.stake.percentage + '%'}"></div>
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                  <!---->
                  <b-row>
                    <b-col class="mb-3 pr-sm-4" cols=12 sm=6>
                      <!--rewards-->
                      <b-row class="box">
                        <b-col cols=6 class="p-0">
                          <p class="m-0 txt-color-secondary">Rewards</p>
                        </b-col>
                        <b-col cols=6 class="p-0 text-right">
                          <p class="m-0 color-primary"><strong>{{this.GLOBAL._toDecimal(this.stake.rewards, 9)}} SGBT</strong></p>
                        </b-col>
                      </b-row>
                    </b-col>
                    <!--Available-->
                    <b-col class="mb-3 pl-sm-4" cols=12 sm=6>
                      <b-row class="box">
                        <b-col cols=6 class="p-0">
                          <p class="m-0 txt-color-secondary">Available</p>
                        </b-col>
                        <b-col cols=6 class="p-0 text-right">
                          <p class="m-0 color-primary"><strong>{{this.GLOBAL._toDecimal(this.stake.available, 9)}} SGBT</strong></p>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                  <!--Paid-->
                  <b-row class='box py-2'>
                    <b-col cols=2 sm=1  class='p-0' style='display: flex;'>
                      <div class='icon'>
                          <div class='wraper'>
                              <SmartGlobalIcon
                                v-bind="{width: 25,height: 25,fill: '#212529'}"
                              />
                          </div>
                      </div>
                    </b-col>
                    <b-col cols=10 sm=11>
                      <b-row class="h-100 align-items-center">
                        <b-col cols=4 class="p-0"><p class="m-0">Paid</p></b-col>
                        <b-col cols=8 class="p-0 text-right"><p class="m-0 color-primary"><strong>{{this.GLOBAL._toDecimal(this.stake.paid, 9)}} SGBT</strong></p></b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-container>
              </b-card>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row class="mb-5">
        <b-col cols=12>
          <h5 class="mb-0 pb-3 text-center txt-color-secondary">List Stake</h5>
        </b-col>
        <b-col cols=12>
          <b-list-group flush>
            <b-card v-if="getListStake.length === 0" no-body class='p-2'>
              <div style="height: 135px; display: flex; justify-content: center; align-items: center;">
                  <h6 class='mb-0 color-primary'>The list is empty</h6>
              </div>
            </b-card>
            <b-list-group-item
              style='background: none;'
              class='p-0 mb-2'
              v-for="(item, index) in getListStake" v-bind:key="index"
              >
              <b-card no-body class='p-4'>
                <b-container>
                  <b-row class='mb-3'>
                    <b-col cols=12 class=''>
                      <b-row class='box pt-3'>
                        <b-col cols=12 sm=6 class="p-0">
                          <h5 class="txt-color-secondary m-0">Stake <span class="color-primary"><strong>{{item._seconds}}</strong></span></h5>
                          <h6 class="" style='color: #A7A4A4'>Ends is {{item.contador}}</h6>
                        </b-col>
                        <b-col cols=12 sm=6 class='txt-color-primary color-primary text-right p-0'>
                          <h6 class='mb-0' ><strong class="pl-1"> {{item.value}} SGBT</strong></h6>
                          <span style="color: #A7A4A4; font-size: 0.8rem;"> -- USD</span>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols=12 sm=6 class="">
                      <b-row>
                        <b-col class="mb-3 pr-sm-4" cols=12>
                          <b-row class="box">
                            <b-col cols=6 class="p-0">
                              <p class="m-0 txt-color-secondary">rewards</p>
                            </b-col>
                            <b-col cols=6 class="p-0 text-right">
                              <p class="m-0 color-primary"><strong>{{item.reward}} SGBT</strong></p>
                            </b-col>
                          </b-row>
                        </b-col>
                        <b-col class="mb-3 pr-sm-4" cols=12>
                          <b-row class="box">
                            <b-col cols=6 class="p-0">
                              <p class="m-0 txt-color-secondary">Available({{item.availablePercentage}}%)</p>
                            </b-col>
                            <b-col cols=6 class="p-0 text-right">
                              <p class="m-0 color-primary"><strong>{{item.available}} SGBT</strong></p>
                            </b-col>
                          </b-row>
                        </b-col>
                        <b-col class="mb-3 mb-sm-0 pr-sm-4" cols=12>
                          <b-row class='box py-2'>
                            <b-col cols=2 sm=3 lg=2  class='p-0' style='display: flex;'>
                              <div class='icon'>
                                  <div class='wraper'>
                                      <SmartGlobalIcon
                                        v-bind="{width: 25,height: 25,fill: '#212529'}"
                                      />
                                  </div>
                              </div>
                            </b-col>
                            <b-col cols=10 sm=9 lg=10>
                              <b-row class="h-100 align-items-center">
                                <b-col cols=4 sm=12 lg=4 class="p-0 text-sm-right text-lg-left"><p class="m-0">Paid</p></b-col>
                                <b-col cols=8 sm=12 lg=8 class="p-0 text-right"><p class="m-0 color-primary"><strong>{{item.paid}}</strong></p></b-col>
                              </b-row>
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-row>
                    </b-col>
                    <b-col cols=12 sm=6>
                      <b-row class="h-100 align-items-center">
                        <b-col cols=12 class="mb-2 mb-sm-0">
                          <b-row>
                            <b-col cols=4 sm=4 lg=3 class="p-0 text-center">
                              <h4 class="color-primary">{{item.percentage}}%</h4>
                            </b-col>
                            <b-col cols=8 sm=8 lg=9 class="p-0">
                              <div class="progress-chart">
                                <div>
                                  <div class="progress" :style="{width: + item.percentage + '%'}"></div>
                                </div>
                              </div>
                            </b-col>
                          </b-row>
                        </b-col>
                        <b-col cols=12 class="p-0 text-right text-lg-right ">
                          <b-button v-if = "!item.liquidate" @click= "onSubmit('liquidate', item.id)" class="btn-sm mr-2 mb-0" style='max-width: 160px;' variant="secondary">Liquidate</b-button>
                          <b-button v-if = "!item.disabled" @click= "onSubmit('withdraw', item.id)" :disabled= "item.disabled " class="btn-sm" style='max-width: 160px;' variant="primary">Withdraw</b-button>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-container>
              </b-card>
              </b-list-group-item>
          </b-list-group>
        </b-col>
      </b-row>
      <b-row class="mb-5">
        <b-col cols=12>
          <h5 class="mb-0 pb-3 text-center txt-color-secondary">Withdrawals</h5>
        </b-col>
        <b-col cols=12>
          <b-card no-body class='py-4'>
            <div v-if="this.withdrawals.length === 0" style="height: 135px; display: flex; justify-content: center; align-items: center;">
              <h6 class='mb-0 color-primary'>The list is empty</h6>
            </div>
            <b-list-group flush>
              <b-list-group-item
                button
                style="background: none;"
                class="mb-2 px-4 py-0"
                v-for="(item, index) in this.withdrawals" v-bind:key="index"
              >
                <b-container class='py-2'>
                  <b-row>
                    <b-col class="p-0 txt-color-secondary text-right text-sm-left" cols=12 sm=6>
                      <p class="m-0">{{item.timestamp}}</p>
                    </b-col>
                    <b-col class="p-0 txt-color-secondary text-right" cols=12 sm=6>
                      <p class="color-primary m-0"><strong>{{item.value}} SGBT</strong></p>
                    </b-col>
                  </b-row>
                </b-container>
              </b-list-group-item>
            </b-list-group>
          </b-card>
        </b-col>
      </b-row>
    </div>
    <div v-else class='container'>
      <b-row class="m-0">
        <b-col cols=12>
          <p class="mb-0 pb-3 text-center txt-color-secondary">Profile view is not available, please connect the wallet to continue. </p>
        </b-col>
      </b-row>
    </div>
    <div style="height: 100px"></div>
    <b-modal id='share-info-id' class='' ref='share-info-id' hide-header hide-footer centered>
      <b-container fluid>
        <b-row class="mt-4">
          <b-col cols=12>
              <b-row  class="">
                  <b-col cols=3 class='text-center'>
                      <b-row>
                        <div class="wrapper">
                          <div class = "img">
                            <UserIcon/>
                            <h5>{{ ID }}</h5>
                          </div>
                        </div>
                      </b-row>
                  </b-col>
                  <b-col cols=9>
                    <h5>Rewards</h5>
                    <p>Receive 10 SGBT for every stake placed through this link.</p>
                  </b-col>
              </b-row>
              <!-- link -->
              <div class='my-3'>
                <mi-link titulo="link" :valor="this.getLink"/>
              </div>
          </b-col>
        </b-row>
      </b-container>
    </b-modal >
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SmartGlobalIcon from '@/components/icons/SmartGlobalIcon'
import ApiWallet from '@/services/ApiWallet.service'
import BalanceItem from '@/components/presale/assets/recompensas/balanceItem'
import UserIcon from '@/components/icons/UserIcon'
import MiLink from '@/components/presale/MiLink'
export default {
  components: {
    SmartGlobalIcon,
    BalanceItem,
    UserIcon,
    MiLink
  },
  data () {
    return {
      isLoggenIn: false,
      userId: 0,
      partner: 0,
      stake: {
        balance: 0,
        paid: 0,
        rewards: 0,
        available: 0,
        percentage: 0,
        count: 0,
        rewardsPartner: {
          balance: 0,
          withdrawals: 0
        }
      },
      list: [],
      withdrawals: [],
      assets: {
        error: false,
        list: [
          {
            name: 'Smart Global Token',
            symbol: 'SGBT',
            protocol: 'trc-20',
            address: 'TCdCXwD9GPmJUVaB64KeGU6ovd34XgFNe7',
            supply: 0,
            instance: null
          },
          {
            name: 'SGBT Stake',
            symbol: 'SGBT-S',
            protocol: 'trc-20',
            address: 'TCnGHiYbN1JiZ3VQbxXnBis1BTnWEzkhdT',
            supply: 0,
            instance: null
          }
        ]
      },
      tronGrid: null
    }
  },
  computed: {
    ...mapGetters({
      getUserAddress: 'getAddress',
      getStatusAuthWallet: 'auth/getStatusAuthWallet',
      getOptionsAuthWallet: 'auth/getOptionsAuthWallet'
    }),
    getListStake () { return this.list },
    ID () { return this.userId.toString().padStart(3, 0) },
    getLink () { return 'https://dashboard.sgbtoken.com/#/earn/stake/home/ref/' + this.userId }
  },
  async created () {
    console.log('created')
    this.update()
  },
  methods: {
    update () {
      if (this.$store.getters.walletIsInstalled) {
        if (this.getStatusAuthWallet === this.getOptionsAuthWallet.LOGGED_IN) {
          this.loggenIn()
        } else {
          if (this.getStatusAuthWallet === this.getOptionsAuthWallet.NOT_LOGGED_IN) {
            this.notLoggedIn()
          }
        }
      } else {
        // NOT LOGGED IN
        if (this.getStatusAuthWallet === this.getOptionsAuthWallet.NOT_LOGGED_IN) {
          this.notLoggedIn()
        }
      }
    },
    async loggenIn () {
      console.log('LOGGED_IN')
      this.$store.commit('setLoading', true)
      try {
        console.log('1')
        this.tronGrid = new ApiWallet()
        console.log('2')
        this.tronGrid.tronWeb.setAddress(this.getUserAddress)
        console.log('3')
        await this.getContractAssets()
        console.log('4')
        if (!this.assets.error) {
          await this.updateALL()
        }
      } catch (e) { console.log({ e }) }
      this.$store.commit('setLoading', false)
    },
    notLoggedIn () {
      console.log('notLoggedIn')
      this.isLoggenIn = false
    },
    async getContractAssets () {
      try {
        if (this.assets.list[0].instance === null) {
          this.assets.list[0].instance = await this.tronGrid.getContract(this.assets.list[0].address)
        }
        //
        if (this.assets.list[1].instance === null) {
          this.assets.list[1].instance = await this.tronGrid.getContract(this.assets.list[1].address)
        }
      } catch (e) {
        this.assets.list[0].instance = null
        this.assets.list[1].instance = null
        this.assets.error = true
        console.log('error: getContractAssets', { e })
      }
    },
    async updateALL () {
      this.isLoggenIn = true
      // set balance
      await this.setAccount()
      // set profile
      await this.setProfile()
      // set list stakes
      await this.setListStakes()
      //
      await this.setWithdrawByAddress()
    },
    async setAccount () {
      console.log('setAccount')
      await this.assets.list[1].instance.getAccount(this.getUserAddress).call()
        .then(resp => {
          console.log('resp', resp)
          this.stake.balance = this.tronGrid.tronWeb.toDecimal(resp.balances._hex)
          this.stake.count = this.tronGrid.tronWeb.toDecimal(resp.count_stakes._hex)
          this.stake.rewardsPartner.balance = this.tronGrid.tronWeb.toDecimal(resp._reward[0]._hex)
          this.stake.rewardsPartner.withdrawals = this.tronGrid.tronWeb.toDecimal(resp._reward[1]._hex)
          this.userId = this.tronGrid.tronWeb.toDecimal(resp.id._hex)
        }).catch(e => {
          console.log('error', { e })
        })
    },
    async setProfile () {
      console.log('setProfile')
      await this.assets.list[1].instance.profile(this.getUserAddress).call()
        .then(resp => {
          console.log({ resp })
          this.stake.rewards = this.tronGrid.tronWeb.toDecimal(resp.reward._hex)
          this.stake.paid = this.tronGrid.tronWeb.toDecimal(resp.paid._hex)
          this.stake.available = this.stake.rewards - this.stake.paid
          this.stake.percentage = this.stake.rewards !== 0 ? Math.trunc((this.stake.paid / this.stake.rewards) * 100) : 0
          console.log('available', this.stake)
        })
        .catch(e => {
          console.log('error', { e })
        })
    },
    async setListStakes () {
      console.log('setListStakes')
      const list = []
      this.list = []
      for (let i = this.stake.count; i > 0; i--) {
        await this.assets.list[1].instance.get_stake(this.getUserAddress, i).call()
          .then(resp => {
            const paid = this.tronGrid.tronWeb.toDecimal(resp.paid._hex)
            const reward = this.tronGrid.tronWeb.toDecimal(resp.reward._hex)
            const end = this.tronGrid.tronWeb.toDecimal(resp.end._hex)
            const last = this.tronGrid.tronWeb.toDecimal(resp.last._hex)
            const seconds = this.tronGrid.tronWeb.toDecimal(resp._seconds._hex)
            const now = (new Date()).getTime() / 1000
            const percentage = now < end ? ((now - last) / seconds) : (reward - paid) / reward
            let liquidate = true
            if (!resp.status) {
              if (now > end) {
                liquidate = false
              }
            }
            const available = Math.trunc(percentage * reward)
            // const availablePercentage = available !== 0 ? Math.trunc((available / reward) * 100) : 0
            list.push({
              id: i,
              contador: this.GLOBAL.timeStr((new Date(end * 1000).getTime() - (new Date()).getTime()) / 1000),
              address: 'axyz',
              value: this.GLOBAL._toDecimal(this.tronGrid.tronWeb.toDecimal(resp.amount._hex), 9),
              _seconds: this.GLOBAL.timeStr(seconds),
              reward: this.GLOBAL._toDecimal(reward, 9),
              paid: this.GLOBAL._toDecimal(paid, 9),
              available: this.GLOBAL._toDecimal(available, 9),
              availablePercentage: Number(percentage * 100).toFixed(0),
              percentage: Math.trunc((paid / reward) * 100),
              liquidate: liquidate,
              disabled: reward === paid,
              status: resp.status
            })
          }).catch(e => {
            console.log('error', { e })
          })
      }
      this.list = list
    },
    /* todas los retiros por direccion de cuenta */
    async setWithdrawByAddress () {
      //
      const options = {
        only_confirmed: false,
        only_unconfirmed: false,
        only_from: true,
        limit: 20,
        contract_address: this.assets.list[1].address
      }
      const list = []
      this.withdrawals = []
      try {
        await this.tronGrid.getTransactionsTRC20(
          this.getUserAddress,
          options
        ).then(async resp => {
          resp.data.data.forEach(element => {
            console.log({ element })
            list.push({
              id: element.transaction_id,
              value: this.GLOBAL._toDecimal(element.value, 9),
              timestamp: new Date(element.block_timestamp).toLocaleString()
            })
          })
        }).catch(e => Promise.reject(e))
      } catch (e) { console.log({ e }) }
      this.withdrawals = list
    },
    async onSubmit (event, id) {
      console.log({ event, id })
      const vm = this
      // notific
      if (vm.tronGrid.readOnly) {
        vm.$notificacionSimple('Error', 'read-only connections.')
        return
      }
      if (event === 'withdrawRewardsPartner') {
        console.log('this.stake.rewardsPartner.balance', this.stake.rewardsPartner.balance)
        if (this.stake.rewardsPartner.balance === 0) {
          this.$notificacionSimple('ERROR', 'Balance is zero!!!')
          return
        }
      }
      const confirm = await vm.$notificacionSimpleConfirm('Notification', 'Purchases take 1-5 minutes to complete. Do you wish to continue?') // ES : Las compras tardan de 1 a 5 minutos en completarse. ¿Desea continuar?
      console.log('confirm', confirm)
      if (!confirm) {
        return
      }
      const call = async () => {
        const options = {
          feeLimit: 100 * Math.pow(10, 6),
          callValue: 0,
          shouldPollResponse: true
        }
        if (event === 'withdraw') {
          return await vm.assets.list[1].instance.withdrawReward(id).send(options)
        } else {
          if (event === 'withdrawRewardsPartner') {
            return await vm.assets.list[1].instance.withdrawPartnerRewards().send(options)
          } else {
            return await vm.assets.list[1].instance.liquidate_stake(id).send(options)
          }
        }
      }
      vm.$store.commit('setLoading', true)
      await call()
        .then(async () => {
          vm.$store.commit('setLoading', false)
          await vm.$notificacionSimple('success', 'The operation was successful.')
        }).catch(async (e) => {
          console.log('error', { e })
          vm.$store.commit('setLoading', false)
          await vm.$notificacionSimple('Error', (e.error) ? e.error : e)
        })
      vm.$store.commit('setLoading', true)
      await vm.updateALL()
      vm.$store.commit('setLoading', false)
    },
    getRecompensas: function () {
      // add icon
      const assets = this.assets.list[0]
      const properties = {
        width: 25,
        height: 25,
        fill: '#1E1E1E'
      }
      return [
        {
          symbol: assets.symbol,
          title: 'Balance',
          value: this.GLOBAL._toDecimal(this.stake.rewardsPartner.balance, 9),
          component: SmartGlobalIcon,
          properties: properties
        },
        {
          symbol: assets.symbol,
          title: 'Withdrawn',
          value: this.GLOBAL._toDecimal(this.stake.rewardsPartner.withdrawals, 9),
          component: SmartGlobalIcon,
          properties: properties
        }
      ]
    },
    shareLink () {
      this.$refs['share-info-id'].show()
      console.log('shareLink')
    }
  }
}
</script>

<style scoped>
.main.center {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}
.btn-l {
  position: absolute;
  top: 0;
  right: 0;
  background-color: #F4C96C;
  color: #282828;
  margin-top: -4px;
  width: 60px;
  height: 32px;
  text-align: center;
  padding-top: 4px;
  border-radius: 9px;
  font-weight: 600;
}

.input {
position: absolute;
  top: 0;
  right: 0;
  color: #F4C96C;
  margin-right: 60px;
  width: 70%;
  text-align: right;
  padding-right: 6px;
  font-weight: 600;
}

.progress-chart {
  border-radius: 33px;
  height: 85%;
  padding: 8px;
  background-color: #2E2E2E;
  position: relative;
}
.progress-chart div {
  width: 100%;
  height: 100%;
  background-color: #414042;
  border-radius: 8px;
}
.progress-chart div div{
    width: 0%;
    background-color: #F4C96C;
}
.box {
  min-height: 32px;
}
</style>
